/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_06_Detail_Amateur_5_HeadingInputs */

const en_method_content_step_06_detail_amateur_5_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conclusion`)
};

const es_method_content_step_06_detail_amateur_5_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conclusión`)
};

const de_method_content_step_06_detail_amateur_5_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abschluss`)
};

const zh_method_content_step_06_detail_amateur_5_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结论`)
};

const ar_method_content_step_06_detail_amateur_5_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الخاتمة`)
};

const fr_method_content_step_06_detail_amateur_5_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`"Conclusion"`)
};

const vi_method_content_step_06_detail_amateur_5_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kết luận`)
};

const sw_method_content_step_06_detail_amateur_5_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hitimisho`)
};

const th_method_content_step_06_detail_amateur_5_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บทสรุป`)
};

const bs_method_content_step_06_detail_amateur_5_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaključak`)
};

const ja_method_content_step_06_detail_amateur_5_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コンテンツ`)
};

const ko_method_content_step_06_detail_amateur_5_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`결론`)
};

const pt_method_content_step_06_detail_amateur_5_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conclusão`)
};

const it_method_content_step_06_detail_amateur_5_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conclusioni`)
};

const sv_method_content_step_06_detail_amateur_5_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slutsats`)
};

const nl_method_content_step_06_detail_amateur_5_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conclusie`)
};

const da_method_content_step_06_detail_amateur_5_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konklusion`)
};

const nb_method_content_step_06_detail_amateur_5_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konklusjon`)
};

const fi_method_content_step_06_detail_amateur_5_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päätelmä`)
};

const pl_method_content_step_06_detail_amateur_5_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wniosek`)
};

const ru_method_content_step_06_detail_amateur_5_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заключение`)
};

const tr_method_content_step_06_detail_amateur_5_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonuç`)
};

const hi_method_content_step_06_detail_amateur_5_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निष्कर्ष`)
};

const id_method_content_step_06_detail_amateur_5_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kesimpulan`)
};

const ms_method_content_step_06_detail_amateur_5_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kesimpulan`)
};

const cs_method_content_step_06_detail_amateur_5_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Závěr`)
};

const el_method_content_step_06_detail_amateur_5_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Συμπέρασμα`)
};

const he_method_content_step_06_detail_amateur_5_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מסקנה`)
};

const af_method_content_step_06_detail_amateur_5_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gevolgtrekking`)
};

const hu_method_content_step_06_detail_amateur_5_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Összegzés`)
};

/**
* | output |
* | --- |
* | "Conclusion" |
*
* @param {Method_Content_Step_06_Detail_Amateur_5_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_06_detail_amateur_5_heading = /** @type {((inputs?: Method_Content_Step_06_Detail_Amateur_5_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_06_Detail_Amateur_5_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_06_detail_amateur_5_heading(inputs)
	if (locale === "de") return de_method_content_step_06_detail_amateur_5_heading(inputs)
	if (locale === "zh") return zh_method_content_step_06_detail_amateur_5_heading(inputs)
	if (locale === "ar") return ar_method_content_step_06_detail_amateur_5_heading(inputs)
	if (locale === "fr") return fr_method_content_step_06_detail_amateur_5_heading(inputs)
	if (locale === "vi") return vi_method_content_step_06_detail_amateur_5_heading(inputs)
	if (locale === "sw") return sw_method_content_step_06_detail_amateur_5_heading(inputs)
	if (locale === "th") return th_method_content_step_06_detail_amateur_5_heading(inputs)
	if (locale === "bs") return bs_method_content_step_06_detail_amateur_5_heading(inputs)
	if (locale === "ja") return ja_method_content_step_06_detail_amateur_5_heading(inputs)
	if (locale === "ko") return ko_method_content_step_06_detail_amateur_5_heading(inputs)
	if (locale === "pt") return pt_method_content_step_06_detail_amateur_5_heading(inputs)
	if (locale === "it") return it_method_content_step_06_detail_amateur_5_heading(inputs)
	if (locale === "sv") return sv_method_content_step_06_detail_amateur_5_heading(inputs)
	if (locale === "nl") return nl_method_content_step_06_detail_amateur_5_heading(inputs)
	if (locale === "da") return da_method_content_step_06_detail_amateur_5_heading(inputs)
	if (locale === "nb") return nb_method_content_step_06_detail_amateur_5_heading(inputs)
	if (locale === "fi") return fi_method_content_step_06_detail_amateur_5_heading(inputs)
	if (locale === "pl") return pl_method_content_step_06_detail_amateur_5_heading(inputs)
	if (locale === "ru") return ru_method_content_step_06_detail_amateur_5_heading(inputs)
	if (locale === "tr") return tr_method_content_step_06_detail_amateur_5_heading(inputs)
	if (locale === "hi") return hi_method_content_step_06_detail_amateur_5_heading(inputs)
	if (locale === "id") return id_method_content_step_06_detail_amateur_5_heading(inputs)
	if (locale === "ms") return ms_method_content_step_06_detail_amateur_5_heading(inputs)
	if (locale === "cs") return cs_method_content_step_06_detail_amateur_5_heading(inputs)
	if (locale === "el") return el_method_content_step_06_detail_amateur_5_heading(inputs)
	if (locale === "he") return he_method_content_step_06_detail_amateur_5_heading(inputs)
	if (locale === "af") return af_method_content_step_06_detail_amateur_5_heading(inputs)
	if (locale === "hu") return hu_method_content_step_06_detail_amateur_5_heading(inputs)
	return en_method_content_step_06_detail_amateur_5_heading(inputs)
});